module.exports = __webpack_public_path__ + "static/header-logo-orange-xd.b8196f61.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/header-logo-orange-xd.png
// module id = 51
// module chunks = 2